import React from 'react'
import About from '../Pages/About'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

function AboutLayout() {
  return (
    <>
    <Header />
    <About />
    <Footer />
    </>
  )
}

export default AboutLayout